import { useEffect } from 'react'
import { createSharedStore } from '../lib/createSharedStore'

export interface Session { user: { id: string; email: string; name?: string | null; image?: string | null } }

type Status = 'probing' | 'signed-out' | 'signed-in'
interface SessionState { status: Status; session: Session | null }

const store = createSharedStore<SessionState>({ status: 'probing', session: null })
let inflight: Promise<void> | null = null

function load() {
  if (inflight) return inflight
  inflight = fetch('/api/auth/get-session', { credentials: 'include' })
    .then(r => (r.ok ? r.json() : null))
    .then((data: Session | null) => {
      store.set(data?.user?.email
        ? { status: 'signed-in', session: data }
        : { status: 'signed-out', session: null })
    })
    .catch(() => store.set({ status: 'signed-out', session: null }))
    .finally(() => { inflight = null })
  return inflight
}

export function useSession(): SessionState & { refresh: () => void; signOut: () => Promise<void> } {
  const state = store.use()
  useEffect(() => {
    if (store.get().status === 'probing') load()
  }, [])
  return {
    ...state,
    refresh: () => { store.set({ status: 'probing', session: store.get().session }); load() },
    signOut: async () => {
      try {
        const res = await fetch('/api/auth/sign-out', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: '{}',
        })
        if (!res.ok) console.error('[auth] sign-out failed', res.status)
      } catch (e) {
        console.error('[auth] sign-out network error', e)
      }
      store.set({ status: 'signed-out', session: null })
    },
  }
}
